import styled from 'styled-components';
import { Input, Text } from '../../../Layouts';
import { color } from '../../../../Assets/color';
import { colorNames } from '../../../../Constants/colors';
import { HoverLink } from '../../../Containers/Authentication/style';

// forms
export const FormContainer = styled.form`
    width: 335px;
    display: flex;
    flex-direction: column;
    align-items: center;

    & input {
        margin-bottom: 42px;
    }
`;

export const SignInFormContainer = styled(FormContainer)`
    & div:nth-child(2) {
        & input {
            margin-bottom: 25px;
        }
    }
`;

export const FormButtonContainer = styled.div`
    width: 245px;
`;

export const SignUpSubmitButtonContainer = styled.div`
    width: 100%;
`;

export const FormInput = styled(Input)`
    background-color: rgba(255, 255, 255, 0.2);
    height: 40px;
`;

export const ErrorMessageComponent = styled.span`
    width: 100%;
    font-size: 14px;
    color: ${color(colorNames.YELLOW)};
    position: absolute;
    left: 0;
    top: 45px;
    text-align: center;
`;

export const ResetPasswordLabelWrapper = styled.div`
    width: 100%;
    margin-bottom: 20px;
`;

export const ResetPasswordLink = styled(HoverLink)`
    font-size: 12px;
    font-weight: 300;
    color: rgba(255, 255, 255, 0.7);
`;

// avatar
export const AvatarWrapper = styled.label`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 28px;
`;

export const AvatarInputContainer = styled.div`
    width: 82px;
    height: 82px;
    overflow: hidden;
    border-radius: 50%;
    position: relative;
    margin-bottom: 10px;
    curosor: pointer;
`;

export const AvatarPreview = styled(AvatarInputContainer)`
    background-image: ${props => (props.background ? `url(${props.background})` : null)};
    background-size: cover;
`;

export const AvatarTextBlock = styled.div`
    position: absolute;
    width: 82px;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.2);
    bottom: 0;
    text-align: center;
    padding: 2px 0 0 0;
    bottom: 0;
    color: #ffffff90;
    font-size: 11px;
    transform: translateY(10px);
    transition: all 0.3s;
    text-transform: uppercase;

    &:hover {
        cursor: pointer;
        transform: translateY(0);
    }
`;

export const AvatarDescriptionText = styled(Text)`
    font-size: 16px;
    font-weight: 100;
`;

export const UploadText = styled(AvatarDescriptionText)`
    font-weight: bold;

    &:hover {
        opacity: 0.75;
    }

    transition: all 0.25s;
    cursor: pointer;
`;

// reset password
export const ResetPasswordFormContainer = styled(FormContainer)`
    & input {
        margin-bottom: 25px;
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Components/forms/AuthenticationForms/style.js